import { render, staticRenderFns } from "./ChangePasswordClientModal.vue?vue&type=template&id=237931bd&lang=pug&"
import script from "./ChangePasswordClientModal.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports